<template>
  <MenuPopover
    trigger="click"
    class="TimelineSettingsMenu"
    :class="{ '-labelled': labelled }"
    :bound-to="{ x: labelled ? 'viewport' : 'container' }"
    :margin="{ left: 8, right: 8 }"
    :trigger-attrs="{ title: $t('timeline.settings_menu') }"
    :items="items"
  >
    <template #trigger>
      <FAIcon
        icon="sliders"
        :fixed-width="labelled"
        :class="{ 'fa-scale-110 menu-icon': labelled }"
      />
      <span
        v-if="labelled"
        class="label"
      >{{ $t('timeline.settings_menu') }}</span>
    </template>
  </MenuPopover>
</template>

<script src="./timeline_settings_menu.js"></script>
